var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.userHasPermissions("provider.specialist.serviceplace.view")
    ? _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                !_vm.disabled || (_vm.disabled && this.locations.length > 0),
              expression: "!disabled || (disabled && this.locations.length > 0)"
            }
          ]
        },
        [
          _c("section-title", {
            attrs: {
              content: "Información de Lugar(es) de Servicio(s)",
              "has-line": true
            }
          }),
          _vm.locations && _vm.locations.length > 0
            ? _c(
                "div",
                { staticClass: "serviceplace-information-list mt-3" },
                [
                  _vm._l(_vm.sortedLocations, function(location, idx) {
                    return [
                      (idx >= _vm.pageStartIndex) & (idx < _vm.pageEndIndex)
                        ? _c(
                            "callout",
                            {
                              key: location.specialistLocationId,
                              staticClass: "mb-2",
                              attrs: {
                                "has-toggle": false,
                                opened: !_vm.disabled && _vm.editMode
                              },
                              scopedSlots: _vm._u(
                                [
                                  _vm.editMode && _vm.editIndex == idx
                                    ? {
                                        key: "edition",
                                        fn: function() {
                                          return [
                                            _c(
                                              "service-place-information-add-edit",
                                              {
                                                attrs: {
                                                  "company-id":
                                                    _vm.specialist.companyId,
                                                  "fiscal-year-id":
                                                    _vm.specialist.fiscalYearId,
                                                  "immediate-save":
                                                    _vm.immediateSave,
                                                  "op-mode": "E",
                                                  "self-assign": _vm.selfAssign,
                                                  "specialist-id":
                                                    _vm.specialistId,
                                                  "unsaved-license-data":
                                                    _vm.specialist.licenses
                                                },
                                                on: {
                                                  "on-cancel":
                                                    _vm.clearEditCreate,
                                                  "on-saved":
                                                    _vm.emitLocationChange
                                                },
                                                model: {
                                                  value:
                                                    _vm.sortedLocations[idx],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.sortedLocations,
                                                      idx,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "sortedLocations[idx]"
                                                }
                                              }
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    : null
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-sm-12 col-md cell sd" },
                                  [
                                    _c("div", { staticClass: "data" }, [
                                      _c("span", [_vm._v("Tipo de Lugar:")]),
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(location.locationTypeName)
                                        )
                                      ])
                                    ])
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-sm-12 col-md cell" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "data d-inline-block" },
                                      [
                                        _c("span", [_vm._v("Municipio:")]),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(location.municipality.name)
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-sm-12 col-md cell" },
                                  [
                                    _c("div", { staticClass: "data" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(location.locationTypeName) +
                                            ":"
                                        )
                                      ]),
                                      _c("p", [
                                        _vm._v(_vm._s(location.locationName))
                                      ])
                                    ])
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-sm-12 col-md-1 col-lg-2 cell"
                                  },
                                  [
                                    location.canAssignSpecialistFlag
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "data d-inline-block"
                                          },
                                          [
                                            _c("custom-balloon", {
                                              staticClass:
                                                "mt-2 pl-2 pr-2 font-weight-normal font-16",
                                              attrs: {
                                                "background-color": "gray",
                                                text: "Admisión"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-sm-12 col-md-1 col-lg-2 cell"
                                  },
                                  [
                                    location.selfAssign
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "data d-inline-block"
                                          },
                                          [
                                            _c("custom-balloon", {
                                              staticClass:
                                                "mt-2 pl-2 pr-2 font-weight-normal font-16",
                                              attrs: {
                                                "background-color": "gray",
                                                text: "Asignar"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                !_vm.disabled && _vm.canPerformActions
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-sm-12 col-md cell pr-5"
                                      },
                                      [
                                        _c("drop-down", {
                                          staticClass: "float-right",
                                          attrs: {
                                            "data-item": idx,
                                            items: _vm.getAvailableActions()
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ])
                            ]
                          )
                        : _vm._e()
                    ]
                  }),
                  !_vm.disabled
                    ? _c("div", { staticClass: "row mt-3" }, [
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            !_vm.editMode &&
                            !_vm.createMode &&
                            _vm.canAddServicePlace
                              ? _c(
                                  "action-button",
                                  {
                                    staticClass: "float-right",
                                    attrs: {
                                      i: "fas fa-file-plus",
                                      variant: "success"
                                    },
                                    on: { click: _vm.onAdd }
                                  },
                                  [_vm._v(" Añadir ")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        this.pagingInfo.totalItemCount > 5
                          ? _c("pagination", {
                              staticClass: "mb-3",
                              attrs: {
                                data: this.pagingInfo,
                                "show-text": true
                              },
                              on: { "pagination-go-page": _vm.setCurrentPage }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ],
                2
              )
            : _c(
                "div",
                { staticClass: "serviceplace-information-list mt-3" },
                [
                  (!_vm.locations || _vm.locations.length == 0) &&
                  _vm.canAddServicePlace &&
                  !_vm.createMode &&
                  !_vm.editMode &&
                  !_vm.disabled
                    ? _c(
                        "callout",
                        {
                          attrs: { "class-main": "py-3", "has-toggle": false }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "row d-flex justify-content-center"
                            },
                            [
                              _c("action-button", {
                                staticClass: "border w-40 btn",
                                attrs: {
                                  i: "fas fa-file-plus color-primary-1",
                                  text:
                                    "Presione aquí para añadir Lugar(es) de Servicio(s)"
                                },
                                on: { click: _vm.onAdd }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
          _c("callout", {
            staticClass: "mb-2",
            attrs: {
              opened: !_vm.disabled && _vm.createMode,
              "show-container": false
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "edition",
                  fn: function() {
                    return [
                      _c("service-place-information-add-edit", {
                        attrs: {
                          "can-add-locations": _vm.canAddLocations,
                          "company-id": _vm.specialist.companyId,
                          "custom-error-message": _vm.addEditCustomErrorMessage,
                          "fiscal-year-id": _vm.specialist.fiscalYearId,
                          "immediate-save": _vm.immediateSave,
                          locations: _vm.locations,
                          "op-mode": "I",
                          "self-assign": _vm.selfAssign,
                          "specialist-id": _vm.specialistId,
                          "unsaved-license-data": _vm.specialist.licenses
                        },
                        on: {
                          "finish-add-location": function($event) {
                            return _vm.$emit("finish-add-location")
                          },
                          "init-add-locations": function($event) {
                            return _vm.$emit("init-add-locations")
                          },
                          "on-cancel": _vm.clearEditCreate,
                          "on-saved": _vm.onLocationAdded
                        },
                        model: {
                          value: _vm.newLocation,
                          callback: function($$v) {
                            _vm.newLocation = $$v
                          },
                          expression: "newLocation"
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              644603238
            )
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }